import { getCsrfToken } from 'query';

export const removeEmail = (email: string) => {
  return fetch(`/profile/emails/${email}.json`, {
    method: 'DELETE',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
    },
  });
};

export const resendVerification = (email: string) => {
  return fetch(`/profile/emails/${email}.json`, {
    method: 'PUT',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    if (response.ok) {
      return response.json().then((res) => {
        return Promise.resolve(res);
      });
    } else {
      return response.json().then((res) => {
        return Promise.reject(res);
      });
    }
  });
};

export const makePrimary = (email: string) => {
  return resendVerification(email);
};

export const leaveOrganization = (membershipId: string) => {
  return fetch(`/memberships/${membershipId}.json`, {
    method: 'DELETE',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
    },
  });
};

export const addEmail = (email: string) => {
  return fetch(`/profile/emails.json`, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email_addresses_user_email: {
        email: email,
      },
    }),
  }).then((response) => {
    if (response.ok) {
      return response.json().then((res) => {
        if (res.redirect) {
          window.location.href = res.redirect;
          // Return a rejected promise so the success handler is not executed before the redirect
          return Promise.reject({ redirect: true });
        }

        return Promise.resolve(res);
      });
    } else {
      return response.json().then((res) => {
        return Promise.reject(res);
      });
    }
  });
};
